import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { assignState } from '@/store/index.js';
import { apiRetrieveLevelList } from '@/services/level.js';

const useLevelStore = defineStore('level', () => {
  const levelList = ref([]);

  const totalLevels = computed(()=> levelList.value.length);

  const dispatchRetrieveLevelList = async () => {
    try {
      const { parsedData } = await apiRetrieveLevelList();

      assignState(levelList, parsedData);
    } catch {
      assignState(levelList, []);
    }
  };

  return {
    levelList,
    totalLevels,
    dispatchRetrieveLevelList,
  };
});

export default useLevelStore;
